/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import 'can/view/view';
import appContext from 'scripts/app-context';
import 'components/brightcove-video/brightcove-video';
import LocalStorageService from 'scripts/services/localstorage-service';
import urlUtil from 'scripts/utils/url';
import deviceUtil from 'scripts/utils/device';
import DomEventsManager from 'scripts/dom-events-manager';

const takeoverTtlLabel = 'videoTakeoverTtl';

export const VideoTakeover = BaseControl.extend({
    init: function() {
        this._super();

        DomEventsManager.subscribe(this);
        const ttlTime =
            LocalStorageService.getItem(takeoverTtlLabel) ||
            this.getCurrentTimestamp();
        this.videoContainer = this.element.find('.s-video');
        if (urlUtil.getHash() == '#watch') {
            this.openTakeover();
        } else if (
            !deviceUtil.isMobile &&
            ttlTime <= this.getCurrentTimestamp()
        ) {
            this.openTakeover();
        } else {
            this.closeTakeover();
        }
        urlUtil.onLocationHashChanged((event) => {
            if (!this.isPlaying && urlUtil.getHash().indexOf('#watch') !== -1) {
                this.openTakeover();
            }
        });

        //ios banner handling
        can.$(window).on('scroll', () => this.onIOSScroll());
        can.$(window).on('touchmove', () => this.onIOSScroll());
        this.onIOSScroll();
    },

    getCurrentTimestamp() {
        return new Date().getTime();
    },

    openTakeover() {
        this.isPlaying = true;
        this.element.fadeIn();
        this.videoContainer.append(
            can.stache(
                '<brightcove-video playsinline="true" autoplay="autoplay" muted="muted" {video-id}="videoId" (ended)="closeTakeover()" />',
            )({
                videoId: this.options.videoId,
                closeTakeover: this.closeTakeover.bind(this),
                autoplay: !deviceUtil.isMobile,
                muted: deviceUtil.isSafari,
            }),
        );
        appContext.model.dispatch('page-scroll-toggle', [true]);
        setTimeout(() => {
            this.element.find('.s-close-btn').fadeIn(500);
            if (this.options.videoCookieTime) {
                LocalStorageService.setItem(
                    takeoverTtlLabel,
                    this.getCurrentTimestamp() +
                        this.options.videoCookieTime * 3600 * 1000,
                );
            }
        }, 5000);
    },

    closeTakeover() {
        this.isPlaying = false;
        this.element.fadeOut();
        this.videoContainer.empty();
        appContext.model.dispatch('page-scroll-toggle', [false]);
        urlUtil.removeHash();
    },

    onIOSScroll() {
        const offset = deviceUtil.getIOSBannerOffset();
        const transformEntry = `translateY(-${offset}px)`;

        this.element.find('.js-close-btn').css({ transform: transformEntry });
    },

    '.js-close-btn click': function() {
        this.closeTakeover();
    },
});
